module.exports = __webpack_public_path__ + "img/default-diagnostics-tab-icon.76d363e2.svg";